module.exports = __webpack_public_path__ + "static/media/bg-search.73c7e6b3.svg";